if(!customElements.get('collection-list')) {
  customElements.define('collection-list',
    class CollectionList extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.getAttribute('data-section-id');
        this.initSlider(this);
      }

      initSlider(self) {
        let sectionId = self.sectionId;
        new Swiper(`#swiper-${sectionId}`, {
          navigation: {
            nextEl: `.swiper-button-next-${sectionId}`,
            prevEl: `.swiper-button-prev-${sectionId}`,
          },
          slidesPerView: 1.2,
          spaceBetween: 4,
          breakpoints: {
            990: {
              slidesPerView: 4,
            },
          },
          mousewheel: {
            forceToAxis: true,
          },
        });
      }
    }
  )
}